import React, { useMemo } from 'react'
import { ActionButtonProps, LabelProps, TagProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'
import ActionButtons from '@/components/ActionButtons'

const ACTIVE_ACTION_BUTTON_VALUES = [
    'web-gameplan-sport',
    'web-standings-sport',
    'web-conference-ticker',
]

const ActionButtonsFooter = ({
    title,
    navigationItems,
}: Pick<TagProps | LabelProps, 'title' | 'navigationItems'>) => {
    const actionButtons = useMemo(() => {
        const actionButtons: ActionButtonProps[] = []
        navigationItems?.forEach(item => {
            if (ACTIVE_ACTION_BUTTON_VALUES.includes(item.value)) {
                actionButtons.push({ title: item.title, href: item.href || '' })
            }
        })
        return actionButtons
    }, [navigationItems])

    if (!actionButtons.length) {
        return null
    }

    return (
        <NonFlexingContainer
            className="bg-none md:bg-white"
            padding={['spacing-6', 'spacing-6', 'spacing-9', 'spacing-11']}
            testID="action-button-footer"
        >
            <NonFlexingContainer paddingBottom="spacing-7">
                <CardHeadline
                    text={`Alles zu ${title}`}
                    cardHeadlineType={['cardHeadlineS', 'cardHeadlineM', 'cardHeadlineS']}
                />
            </NonFlexingContainer>
            <NonFlexingContainer
                backgroundColor="pearl"
                padding={['spacing-6', 'spacing-6', 'spacing-6', 'spacing-none']}
            >
                <ActionButtons actionButtons={actionButtons} />
            </NonFlexingContainer>
        </NonFlexingContainer>
    )
}

export default ActionButtonsFooter
